import React, { useEffect, useState } from 'react';
import request from '../../../Helpers/API';
import { useHistory } from "react-router-dom";
import PlantillaScreen from '../../helpers/PlantillaScreen';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { LoaderScreen } from '../../components/LoaderScreen';

export const ListadoVendedores = () => {
    const history = useHistory();
    const [data, setData] = useState([]);

    const onHome = () => {
        history.push("/Ventas/Main")
    };

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ListadoVendedores/Obtener_Vendedores`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData(result)
                // console.log(result)
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
            })
    }, []);

    return (
        <PlantillaScreen
            titulo={"LISTADO DE VENDEDORES"}
            className_main={1}
            className={"listado-vendedores"}
        >
            <LoaderScreen loader={loader} />
            <div>
                <div className='home'
                    onClick={() => onHome()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
            </div>
                <div className='listado-vendedores-encabezado'>
                        <div className="listado-vendedores-Container">
                            <div className='listado-vendedores-tabla scroll-4'>
                                <table cellPadding={0} cellSpacing={0}>
                                    <thead>
                                        <tr className='listado-vendedores-tabla-columnas'>
                                            <th className="columna-id">ID</th>
                                            <th>
                                                <div className='columna-nombre'>NOMBRE DE VENDEDOR</div>
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((item) => (
                                            <tr >
                                                <td className='listado-id-empleado'>{item.idempleado}</td>
                                                <td>{item.empleado}</td>
                                                <td className='ultima-row'><div className='listado-vendedores-boton-editar' onClick={() => history.push("/Ventas/ScorecardVendedor", item)}>Editar</div></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                </div>
        </PlantillaScreen>
    )
}